import { useLingui } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';

import { FormPage } from '@/components/page/FormPage';
import { FAQForm } from '@/features/faqs/FAQForm';
import { trpc } from '@/services/trpc';

export const Route = createFileRoute('/_baseLayout/chats/$chatId/faqs/create')({
  component: FAQsCreatePage,
  loader: async ({ context: { trpcUtils }, params: { chatId } }) =>
    trpcUtils.chats.findOne.ensureData({ id: chatId }),
});

export function FAQsCreatePage() {
  const { chatId } = Route.useParams();
  const [data] = trpc.chats.findOne.useSuspenseQuery({ id: chatId });
  const { t } = useLingui();

  return (
    <FormPage
      title={t`Create FAQ`}
      breadcrumbs={[
        {
          label: data.name,
          to: '/chats/$chatId/edit',
          params: { chatId },
        },
        {
          label: t`FAQs`,
          to: '/chats/$chatId/faqs',
          params: { chatId },
        },
        { label: t`Create FAQ` },
      ]}
    >
      <FAQForm chatId={chatId} />
    </FormPage>
  );
}
